module.exports = __webpack_public_path__ + "assets/images/rbyearend-15.jpg?v=0ba7b414";